/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { translation } from 'plugin/liferay-widgets-react-web';

import StateSelect from './StateSelect';
import { FormControl } from 'external/react-bootstrap';
import { FliwasFormGrid, FliwasFormGroup, FliwasFormHeading, FormValidationUtil, DateTimePicker } from 'plugin/base-portlet';
import datefns from 'external/datefns';


const validate = formData => {
    let commentValid, stateIdValid;
    commentValid = FormValidationUtil.validateStringMinLengthMaxLength(formData.comment, 1, 3999, 'Beschreibung');

    if (!(formData.stateId > 0)) {
        stateIdValid = 'Bitte Zustand auswählen!';
    }

    return {
        comment: commentValid,
        stateId: stateIdValid
    };
};


class StateValueEditForm extends React.Component {

    constructor(props) {
        super(props);
        this.props.onChange(this.props.formData, validate(this.props.formData));
    }

    handleStateChange(id) {
        this.change('stateId', id);
    }

    handleChange(field, e) {
        this.change(field, e.target.value);
    }

    onTimeChanged(time){
        const t = datefns.startOfMinute(new Date(time.date)).getTime();
        this.change('userTimestamp', t);
    }

    change(field, value) {

        const formData = this.props.formData,
            item = formData.item || formData;

        const newData = {
            ...item,
            [ field ]: value
        };

        this.props.onChange(newData, validate(newData));
    }


    render() {

        const { formData, formValidation } = this.props;

        return (
            <FliwasFormGrid>
                <FliwasFormHeading title={'Zustand setzen'}/>

                <FliwasFormGroup title={'Zustand'}
                                 formValidation={formValidation}
                                 propName={formData.propName}
                                 required>
                    <StateSelect name="stateId"
                                 required
                                 className={formData.className}
                                 propName={formData.propName}
                                 onChange={this.handleStateChange.bind(this)}
                                 currentKey={formData && formData.stateId}/>
                </FliwasFormGroup>
                <FliwasFormGroup title={translation.trans('description')}
                                 formValidation={formValidation}
                                 propName={'comment'}
                                 required>
                    <FormControl as="textarea"
                                 placeholder={translation.trans('description')}
                                 rows={3}
                                 cols={40}
                                 required
                                 value={formData && formData.comment ? formData.comment : ''}
                                 onChange={this.handleChange.bind(this, 'comment')}/>
                </FliwasFormGroup>

{/*                <FliwasFormGroup
                    title={'Eingabezeitpunkt'}
                    formValidation={formValidation}
                    propName={'userTimestamp'}
                >
                    <FormControl
                        type="hidden"
                        placeholder={translation.trans('userTimestamp')}
                        value={formData && formData.userTimestamp ? formData.userTimestamp : ''}
                    />

                    <DateTimePicker
                        onChange={this.onTimeChanged.bind(this)}
                        showTimeSelect
                        startDate={formData && formData.userTimestamp}
                        maxDate={Date.now()}
                        minTime={datefns.startOfDay(new Date())}
                        maxTime={new Date()}
                        inline
                    />
                </FliwasFormGroup>*/}
            </FliwasFormGrid>
        );
    }
}

StateValueEditForm.propTypes = {
    formValidation: PropTypes.object,
    formData: PropTypes.object,
    onChange: PropTypes.func,
    states: PropTypes.array
};

export default StateValueEditForm;



// WEBPACK FOOTER //
// ./js/components/StateValueEditForm.jsx